<template>
  <div class="container">
    <div class="mb-3">
      <v-button
        icon="home"
        text="phrase.back_to_dashboard"
        :route-to="{name: 'dashboard'}"
      />
    </div>
    <div class="row">
      <div class="col-md-9">
        <v-research-set
          v-if="researchSet"
          :research-set="researchSet"
          :is-clickable="false"
        />
      </div>
      <div class="col-md-3">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-building text-cr-red-black mr-2"></i> {{ $tc('word.organisation', 2) }}
          </div>
          <div class="table-logo">
            <table
              class="table mb-0"
            >
              <tr
                v-for="organisation in organisations" :key="organisation.slug"
                class="clickable row-logo"
                @click="goToOrganisation(organisation.slug)"
              >
                <td
                  class="cell-logo d-flex justify-content-center align-items-center"
                >
                  <img
                    :src="organisation.logo"
                    v-if="organisation.logo"
                    class="img-logo"
                    :alt="organisation.name"
                  >
                  <h5 class="m-0" v-else>{{ organisation.name }}</h5>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchResearchSetOrganisations } from '@/reviewer/api';
import { pageNotFound } from '@/common/utils/notify';
import { fetchResearchSet } from '@/public/api';
import Button from '@/common/components/Button.vue';
import ResearchSet from '@/reviewer/components/ResearchSet.vue';

export default {
  name: 'ResearchSet',
  components: {
    'v-research-set': ResearchSet,
    'v-button': Button,
  },
  data() {
    return {
      researchSet: null,
      organisations: null,
    };
  },
  computed: {},
  methods: {
    async fetchResearchSet() {
      const response = await fetchResearchSet(this.$route.params.uuid);
      if (response.status === 200) {
        this.researchSet = response.data;
      } else {
        pageNotFound();
        await this.$router.push({ name: 'dashboard' });
      }
    },
    async fetchResearchSetOrganisations() {
      const response = await fetchResearchSetOrganisations(this.$route.params.uuid);
      if (response.status === 200) {
        this.organisations = response.data;
      } else {
        pageNotFound();
        await this.$router.push({ name: 'dashboard' });
      }
    },
    goToOrganisation(slug) {
      this.$router.push({ name: 'organisation-detail', params: { slug } });
    },
  },
  created() {
    this.fetchResearchSet();
    this.fetchResearchSetOrganisations();
  },
};
</script>

<style>
.img-logo {
  max-height: 100px;
  max-width: 100%;
  width: auto;
  height: auto;
}

.table-logo {
  max-height: 65vh;
  overflow: auto;
}

.row-logo:hover {
  background: #f5f5f5;
}

.cell-logo {
  min-height: 100px;
}
</style>
